<div class="table-container">
  <table id="table" class="table-block">
    <tr *ngIf="isSlokaType && !isUserList" class="table-sloka-type-rows">
      <th>S. No.</th>
      <th>Title</th>
      <th>Description</th>
      <th>Total Slokas</th>
      <th></th>
    </tr>
    <tr *ngIf="!isSlokaType && !isUserList" class="table-sloka-rows">
      <th>S. No.</th>
      <th>Title</th>
      <th>Synopsis</th>
      <th>English</th>
      <th>Sanskrit</th>
      <th>Both</th>
      <th>Video</th>
      <th>Audio</th>
      <th>PDF</th>
      <th></th>
    </tr>
    <tr *ngIf="isUserList" style="margin-top: 2rem" class="table-sloka-type-rows">
      <th>S. No.</th>
      <th>Name</th>
      <th>Email</th>
      <th>Providers</th>
      <th></th>
    </tr>
    <div class="table-row-block" *ngIf="isSlokaType && !isUserList">
      <tr
          *ngFor="
                  let data of tableData
                  | paginate: { itemsPerPage: 10, currentPage: page };
                  let i = index
                  "
          class="table-sloka-type-rows"
          >
          <td>{{ page * 10 - 10 + (i + 1) }}</td>
          <td class="table-title-block">
            <img
                class="table-title-block__circle-image"
                src="{{ data.imageUrl }}"
                />
            <div>{{ data.title }}</div>
          </td>
          <td>{{ data.description }}</td>
          <td>{{ data.totalSlokas }}</td>
          <td>
            <div class="action-block">
              <div (click)="onViewClick(data)">
                <ng-container *ngTemplateOutlet="viewIcon"></ng-container>
              </div>
              <div (click)="onAddSlokaClick(data)">
                <ng-container *ngTemplateOutlet="addSlokaIcon"></ng-container>
              </div>
              <div (click)="onEditClick(data)">
                <ng-container *ngTemplateOutlet="editIcon"></ng-container>
              </div>
              <div (click)="onDeleteClick(data)">
                <ng-container *ngTemplateOutlet="deleteIcon"></ng-container>
              </div>
            </div>
          </td>
      </tr>
    </div>
    <div class="table-row-block" *ngIf="!isSlokaType && !isUserList">
      <tr
          *ngFor="
                  let data of tableData
                  | paginate: { itemsPerPage: 10, currentPage: page };
                  let i = index
                  "
          class="table-sloka-rows"
          >
          <td>{{ page * 10 - 10 + (i + 1) }}</td>
          <td>{{ data.title }}</td>
          <td>{{ data.synopsis }}</td>
          <td>
            <ng-container
                *ngTemplateOutlet="data.english != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td>
            <ng-container
                *ngTemplateOutlet="data.sanskrit != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td>
            <ng-container
                *ngTemplateOutlet="data.both != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td (click)="onVideoLinkClick(data)">
            <ng-container
                *ngTemplateOutlet="data.videoLink != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td (click)="onAudioLinkClick(data)">
            <ng-container
                *ngTemplateOutlet="data.audioLink != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td (click)="onPdfLinkClick(data)">
            <ng-container
                *ngTemplateOutlet="data.pdfLink != '' ? tickIcon : crossIcon"
                ></ng-container>
          </td>
          <td>
            <div class="action-block">
              <div (click)="onViewClick(data)">
                <ng-container *ngTemplateOutlet="viewIcon"></ng-container>
              </div>
              <div (click)="onEditClick(data)">
                <ng-container *ngTemplateOutlet="editIcon"></ng-container>
              </div>
              <div (click)="onDeleteClick(data)">
                <ng-container *ngTemplateOutlet="deleteIcon"></ng-container>
              </div>
            </div>
          </td>
      </tr>
    </div>
    <div class="table-row-block" *ngIf="isUserList">
      <tr
          *ngFor="
                  let data of tableData
                  | paginate: { itemsPerPage: 10, currentPage: page };
                  let i = index
                  "
          class="table-sloka-type-rows"
          >
          <td>{{ page * 10 - 10 + (i + 1) }}</td>
          <td class="table-title-block">
            <div>{{ data.displayName }}</div>
          </td>
          <td>{{ data.email }}</td>
          <td>
            <div
                *ngFor="let p of data.provider"
                >
              <div *ngIf="p == 'google'">

            <img style="width: 2.5rem; height: 2.5rem" src="../../../assets/images/google.png"
                />
              </div>
              <div *ngIf="p == 'apple'">
            <img style="width: 2.5rem; height: 2.5rem; margin-left: 1rem" src="../../../assets/images/apple.png"
                />
              </div>
            </div>
          </td>
      </tr>
    </div>
  </table>
</div>

<ng-template #crossIcon>
  <svg class="cross-icon" viewBox="0 0 311 311.07733">
    <path
        d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0"
        />
    <path
        d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0"
        />
  </svg>
</ng-template>

<ng-template #tickIcon>
  <svg viewBox="0 0 512 512" class="tick-icon">
    <g>
    <g>
    <path
        d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
                               c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
                               C514.5,101.703,514.499,85.494,504.502,75.496z"
        />
    </g>
    </g>
  </svg>
</ng-template>

<ng-template #deleteIcon>
  <svg viewBox="0 0 24 24" class="delete-icon">
    <path
        d="m18.5 24h-13c-1.379 0-2.5-1.122-2.5-2.5v-14c0-.276.224-.5.5-.5h17c.276 0 .5.224.5.5v14c0 1.378-1.121 2.5-2.5 2.5zm-14.5-16v13.5c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-13.5z"
        />
    <path
        d="m22.5 8h-21c-.276 0-.5-.224-.5-.5v-2c0-1.378 1.121-2.5 2.5-2.5h17c1.379 0 2.5 1.122 2.5 2.5v2c0 .276-.224.5-.5.5zm-20.5-1h20v-1.5c0-.827-.673-1.5-1.5-1.5h-17c-.827 0-1.5.673-1.5 1.5z"
        />
    <path
        d="m15.5 4h-7c-.276 0-.5-.224-.5-.5v-2c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5v2c0 .276-.224.5-.5.5zm-6.5-1h6v-1.5c0-.276-.225-.5-.5-.5h-5c-.275 0-.5.224-.5.5z"
        />
    <path
        d="m7.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z"
        />
    <path
        d="m12 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z"
        />
    <path
        d="m16.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z"
        />
  </svg>
</ng-template>
<ng-template #editIcon>
  <svg class="table-edit-icon" viewBox="0 0 24 24">
    <g id="XMLID_1_">
    <path
        d="m22.06 7.6-14 13.99c.2-.19.2-.51 0-.7l-.35-.35 13.29-13.3-.35-.35c.09.09.22.15.35.15s.26-.06.35-.15l.36-.35.35.35c.19.19.19.51 0 .71z"
        />
    <path
        d="m23.12 5.12-1.41 1.42-.71-.71 1.41-1.42c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.41c-.77-.78-2.05-.78-2.82 0l-1.42 1.41-.7-.7 1.41-1.42c1.17-1.17 3.07-1.17 4.24 0 .57.57.88 1.32.88 2.12s-.31 1.55-.88 2.12z"
        />
    <path
        d="m21 5.83.71.71-.36.35c-.09.09-.22.15-.35.15s-.26-.06-.35-.15l-3.54-3.54c-.19-.19-.19-.51 0-.7l.36-.35.7.7z"
        />
    <path
        d="m15.69 3.35-.35-.35 1.06-1.06c.19-.19.52-.19.71 0l.36.36-.36.35c-.19.19-.19.51 0 .7l-.35-.35-1.06 1.07-.01-.01c.2-.19.2-.51 0-.71z"
        />
    <path d="m15.34 3 .35.35c.2.2.2.52 0 .71-.19.2-.51.2-.7 0l-.35-.35z" />
    <path d="m7.9 21.7c.06-.02.12-.06.16-.11-.04.05-.1.08-.16.11z" />
    <path
        d="m7.71 21.74c-.13 0-.26-.05-.35-.15l-.58-.58.67-.21.26-.26.35.35c.2.19.2.51 0 .7-.04.05-.1.09-.16.11-.06.03-.12.04-.19.04z"
        />
    <path
        d="m12.16 3.35-4.95 4.95c-.1.1-.22.15-.35.15s-.26-.05-.36-.15c-.19-.19-.19-.51 0-.7l4.95-4.95c.95-.95 2.6-.95 3.54 0l.35.35-.7.71-.36-.36c-.56-.56-1.55-.56-2.12 0z"
        />
    <path d="m3.47 16.29 4.24 4.25-.26.26-.67.21-3.79-3.79.21-.66z" />
    <path
        d="m3.2 16.56-.21.66-.58-.58c-.15-.14-.19-.36-.11-.54.02-.06.06-.11.11-.16.19-.2.51-.2.71 0l.35.35z"
        />
    <path
        d="m15.7 4.07-12.23 12.22-.35-.35c-.2-.2-.52-.2-.71 0l12.23-12.23.35.35c.19.2.51.2.7 0z"
        />
    <path d="m2.41 15.94c-.05.05-.09.1-.11.16.03-.06.06-.12.11-.16z" />
    <path
        d="m7.86 21.72-7.21 2.26c-.05.01-.1.02-.15.02-.13 0-.26-.05-.35-.15-.14-.13-.18-.32-.13-.5l2.26-7.21c.01-.01.01-.03.02-.04-.08.18-.04.4.11.54l.58.58-1.73 5.52 5.52-1.73.58.58c.09.1.22.15.35.15.07 0 .13-.01.19-.04-.01.01-.03.01-.04.02z"
        />
    </g>
  </svg>
</ng-template>

<ng-template #addSlokaIcon>
  <svg class="add-sloka-icon" viewBox="0 0 24 24">
    <path
        d="m9.02 21h-6.52c-1.378 0-2.5-1.121-2.5-2.5v-16c0-1.379 1.122-2.5 2.5-2.5h12c1.378 0 2.5 1.121 2.5 2.5v6.06c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-6.06c0-.827-.673-1.5-1.5-1.5h-12c-.827 0-1.5.673-1.5 1.5v16c0 .827.673 1.5 1.5 1.5h6.52c.276 0 .5.224.5.5s-.224.5-.5.5z"
        />
    <path
        d="m13.5 9h-10c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h10c.276 0 .5.224.5.5s-.224.5-.5.5z"
        />
    <path
        d="m9.5 13h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z"
        />
    <path
        d="m8.5 5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.276 0 .5.224.5.5s-.224.5-.5.5z"
        />
    <path
        d="m17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.468-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.467-5.5-5.5-5.5z"
        />
    <path
        d="m17.5 21c-.276 0-.5-.224-.5-.5v-6c0-.276.224-.5.5-.5s.5.224.5.5v6c0 .276-.224.5-.5.5z"
        />
    <path
        d="m20.5 18h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z"
        />
  </svg>
</ng-template>

<ng-template #viewIcon>
  <svg class="view-icon" viewBox="0 0 512 512">
    <g>
    <g>
    <path
        d="M510.677,251.069c-25.39-43.889-61.9-80.699-105.581-106.45C360.087,118.087,308.53,104.062,256,104.062
                               s-104.087,14.025-149.095,40.557C63.223,170.37,26.714,207.18,1.323,251.069c-1.764,3.05-1.764,6.811,0,9.861
                               c25.39,43.889,61.9,80.699,105.581,106.45c45.009,26.532,96.565,40.557,149.095,40.557s104.087-14.025,149.095-40.557
                               c43.681-25.751,80.191-62.56,105.581-106.45C512.441,257.88,512.441,254.12,510.677,251.069z M256,388.244
                               c-95.715,0-185.117-50.529-234.71-132.245C70.883,174.284,160.285,123.755,256,123.755s185.117,50.529,234.71,132.245
                               C441.117,337.716,351.715,388.244,256,388.244z"
        />
    </g>
    </g>
    <g>
    <g>
    <path
        d="M256,137.846c-65.15,0-118.154,53.004-118.154,118.154S190.85,374.153,256,374.153s118.154-53.004,118.154-118.154
                               S321.15,137.846,256,137.846z M256,354.461c-54.293,0-98.462-44.17-98.462-98.462s44.169-98.462,98.462-98.462
                               s98.462,44.17,98.462,98.462S310.293,354.461,256,354.461z"
        />
    </g>
    </g>
    <g>
    <g>
    <path
        d="M315.077,246.011c-5.437,0-9.846,4.408-9.846,9.846v0.143c0,5.438,4.409,9.846,9.846,9.846
                               c5.437,0,9.846-4.408,9.846-9.846v-0.144C324.923,250.419,320.515,246.011,315.077,246.011z"
        />
    </g>
    </g>
    <g>
    <g>
    <path
        d="M315.525,221.238c-12.327-21.071-35.136-34.161-59.525-34.161c-5.437,0-9.846,4.408-9.846,9.846
                               c0,5.438,4.409,9.846,9.846,9.846c17.422,0,33.718,9.354,42.529,24.413c1.831,3.131,5.124,4.876,8.508,4.876
                               c1.689,0,3.4-0.434,4.962-1.349C316.693,231.962,318.271,225.93,315.525,221.238z"
        />
    </g>
    </g>
  </svg>
</ng-template>

<ng-template #googleIcon>
  <svg class="view-icon"viewBox="0 0 512.000000 512.000000">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
       fill="#000000" stroke="none">
    <path d="M2367 5110 c-323 -25 -644 -113 -933 -255 -156 -77 -355 -203 -478
             -303 -139 -113 -316 -294 -413 -422 -10 -14 56 -84 416 -444 l428 -428 58 84
             c73 104 236 267 335 335 168 115 372 197 567 229 118 19 378 14 488 -11 266
             -59 479 -175 683 -370 l108 -104 423 423 422 422 -129 126 c-396 383 -874 620
             -1408 697 -163 24 -414 33 -567 21z"/>
    <path d="M2560 2545 l0 -595 611 0 611 0 -32 -57 c-127 -227 -341 -433 -574
             -550 -168 -85 -391 -143 -548 -143 l-68 0 0 -599 0 -600 33 4 c17 2 84 6 148
             9 268 12 597 93 859 212 824 375 1375 1115 1495 2009 25 180 22 490 -5 675
             -12 80 -24 163 -28 185 l-7 40 -1248 3 -1247 2 0 -595z"/>
    </g>
  </svg>
</ng-template>

<ng-template #appleIcon>
  <svg class="view-icon" viewBox="0 0 512.000000 512.000000">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
       fill="#000000" stroke="none">
    <path d="M3455 5113 c-57 -8 -177 -45 -258 -79 -357 -153 -624 -473 -703 -844
              -14 -66 -19 -255 -8 -284 11 -29 129 -19 269 24 335 102 623 407 728 770 34
              115 51 256 42 346 -7 79 -3 76 -70 67z"/>
    <path d="M1496 3905 c-273 -52 -526 -200 -742 -436 -196 -214 -310 -467 -358
              -794 -61 -423 10 -919 199 -1390 152 -378 399 -770 634 -1006 208 -208 384
              -290 590 -276 105 7 155 22 339 98 173 72 263 97 404 109 201 18 361 -11 586
              -109 171 -74 226 -90 327 -97 301 -21 578 192 920 710 62 94 140 221 173 281
              59 106 172 345 172 363 0 5 -29 21 -64 36 -151 65 -345 226 -446 372 -269 389
              -278 895 -22 1283 60 91 202 230 300 295 l90 60 -59 67 c-202 227 -478 386
              -748 433 -228 39 -435 10 -741 -104 -204 -76 -276 -93 -405 -93 -135 1 -201
              16 -447 100 -102 35 -226 72 -275 83 -121 27 -324 34 -427 15z"/>
    </g>
  </svg>
</ng-template>
